<div class="ai-composer">
  <!-- Starter chips — only while the thread is still empty -->
  <div class="ai-composer-suggestions" *ngIf="showSuggestions()">
    <ui-button
      *ngFor="let suggestion of suggestions"
      type="noBorderDefault"
      size="s"
      [text]="suggestion.labelKey | translate"
      [disabled]="busy()"
      (clickAction)="useSuggestion(suggestion)"
    ></ui-button>
  </div>

  <div class="ai-composer-row">
    <textarea
      #composerInput
      class="ai-composer-input"
      [attr.rows]="minRows"
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
      (keydown)="onKeyDown($event)"
      [placeholder]="'SEARCH_GLOBAL_MODAL.AI_CHAT_PLACEHOLDER' | translate"
      autocomplete="off"
    ></textarea>

    <!-- Send while idle, Stop while the agent streams — same slot, so the row layout never shifts -->
    <ui-button
      *ngIf="!busy()"
      type="primary"
      size="s"
      iconClass="ui-icon-arrow"
      [disabled]="!canSubmit()"
      (clickAction)="submit()"
    ></ui-button>

    <ui-button
      *ngIf="busy()"
      type="secondary"
      size="s"
      iconClass="ui-icon-stop"
      [attr.aria-label]="'SEARCH_GLOBAL_MODAL.AI_STOP' | translate"
      [title]="'SEARCH_GLOBAL_MODAL.AI_STOP' | translate"
      (clickAction)="stop()"
    ></ui-button>
  </div>

  <span class="ai-composer-hint">
    {{ 'SEARCH_GLOBAL_MODAL.AI_COMPOSER.HINT' | translate }}
  </span>
</div>
